import * as React from 'react';
import classnames from 'classnames';

import { renderPrice } from 'utils/helper/price';
import { __t, applyTranslations } from 'utils/language';
import { getDisplayDate } from 'utils/date';

import './campaign-payouts-installments-modal-unallocated.scss';

applyTranslations(require('./campaign-payouts-installments-modal-unallocated.i18n.json'));

type Props = {
  budget: number,
  campaignEndDatetime: string
};

const CampaignPayoutsInstallmentsModalUnallocated = (
  {
    budget,
    campaignEndDatetime
  }: Props
): JSX.Element => {
  const totalBudgetClasses = classnames({
    'campaign-payouts-installments-modal-unallocated__details--total': true,
    'campaign-payouts-installments-modal-unallocated__details--total-error': budget < 0
  });

  return (
    <section
      className="campaign-payouts-installments-modal-unallocated"
      data-qa="campaign-payouts-installments-modal-unallocated"
    >
      <div className="campaign-payouts-installments-modal-unallocated__details">
        <span className="campaign-payouts-installments-modal-unallocated__details--label">
          {__t('campaign_payouts_installments_modal_unallocated.labels.unallocated_amount')}
        </span>
        <span className={totalBudgetClasses}>
          {renderPrice(budget)}
        </span>
        <span className="campaign-payouts-installments-modal-unallocated__details--date">
          {getDisplayDate(campaignEndDatetime)}
        </span>
      </div>
      <div className="campaign-payouts-installments-modal-unallocated__subtext">
        {__t('campaign_payouts_installments_modal_unallocated.labels.unallocated_subtext')}
      </div>
    </section>
  );
};

export default CampaignPayoutsInstallmentsModalUnallocated;
